import { createStore, createEffect } from 'effector';
import autoServiceGroupApi from '../../../utils/autoServiceGroupApi';

export const setOptions = createEffect('set options').use(async () => {
  const result = await autoServiceGroupApi.getSelectFilterOptionsV2([{ brands_with_logos: true }]);

  const unifyBrands = result.brands.reduce((currentBrands, brand) => {
    const hasBrand = currentBrands.find(currentBrandItem => currentBrandItem.title === brand.title)
    return hasBrand ? [...currentBrands] : [...currentBrands, brand]
  }, [])
  
  const parsedFilters = {
    transmissions: result.shifts,
    brands: unifyBrands,
    categories: result.categories,
    models: result.models,
    price: result.prices,
    colors: result.colors,
    units: result.units,
  }

  return {
    options: parsedFilters,
  }
});

const FilterV3Options = (() => {
  let instance;

  return (
    defaultValue = {
      options: {},
      loading: true,
      hasError: false,
    },
  ) => {
    if (!instance) {
      instance = createStore(defaultValue);
    }

    instance.on(setOptions.pending, (state, loading) => ({
      ...state,
      loading,
    }));

    instance.on(setOptions.fail, state => ({
      ...state,
      loading: false,
      hasError: true,
    }));

    instance.on(setOptions.done, (state, res) => ({
      ...state,
      options: res.result.options,
      loading: false,
    }));

    return instance;
  };
})();

export default FilterV3Options;
